export enum PhoneNumberStatus {
  NOT_SET = -1,
  UNKNOWN,
  SORENSON_REGISTRATION,
  OTHER_REGISTRATION,
  NOT_REGISTERED,
  EMERGENCY_REGISTRATION,
  PROVISIONAL_REGISTRATION,
}

export interface PhoneNumberRegistration {
  Type: PhoneNumberStatus;
}

export interface PhoneNumberCoreResolution {
  AnonymousCallerBlocked: boolean;
  CallerBlocked: boolean;
  DialString: string;
  Name: string;
  NewNumber: string;
  PhoneOnlineFlag: boolean;
  Source: string;
  URIList: URI[];
  VideoMsgData: {
    NumberRings: number | string;
  };
}

export interface URI {
  Network: string;
  Priority: number;
  Preference: number;
  Value: string;
}
